module.exports = __webpack_public_path__ + "static/Roman_Grotesque_WEB-Light-6dc8775d55a1a6ebea29ecebbd326560.woff2";